/* MCR · product upsell: complementary recommendations swap, premium sliders,
   "frequently bought together" bundle and recently viewed. */
(function () {
  'use strict';
  if (window.MCRUpsell) return;
  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RV_KEY = 'mcr:recent:v1';

  function money(cents) {
    if (window.MCRProduct && window.MCRProduct.formatMoney) return window.MCRProduct.formatMoney(cents);
    return '₹' + (cents / 100).toFixed(2);
  }
  function whenIdle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2000 });
    else setTimeout(fn, 200);
  }
  function onVisible(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      fn();
    }, { rootMargin: '0px 0px 500px 0px' });
    io.observe(el);
  }

  /* ---------- slider arrows ---------- */
  function initSlider(root) {
    if (root.__mcr) return;
    root.__mcr = true;
    var track = root.querySelector('[data-mcr-track]');
    var prev = root.querySelector('[data-mcr-prev]');
    var next = root.querySelector('[data-mcr-next]');
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('is-static', max <= 0);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- frequently bought together ---------- */
  function initBundle(box) {
    if (box.__mcr) { box.__mcrRecalc && box.__mcrRecalc(); return; }
    box.__mcr = true;
    var totalEl = box.querySelector('[data-mcr-fbt-total]');
    var compareEl = box.querySelector('[data-mcr-fbt-compare]');
    var btn = box.querySelector('[data-mcr-fbt-add]');
    var label = box.querySelector('[data-mcr-fbt-label]');
    var err = box.querySelector('[data-mcr-fbt-error]');

    function rows() { return Array.prototype.slice.call(box.querySelectorAll('[data-mcr-fbt-item]')); }
    function selected(row) {
      var input = row.querySelector('[data-mcr-fbt-variant]');
      if (!input) return null;
      if (input.tagName === 'SELECT') {
        var opt = input.options[input.selectedIndex];
        return opt && !opt.disabled ? { id: input.value, price: +opt.dataset.price || 0, compare: +opt.dataset.compare || 0 } : null;
      }
      return { id: input.value, price: +input.dataset.price || 0, compare: +input.dataset.compare || 0 };
    }
    function recalc() {
      var total = 0, compare = 0, count = 0;
      rows().forEach(function (row) {
        var on = row.querySelector('[data-mcr-fbt-check]').checked;
        var v = selected(row);
        row.classList.toggle('is-off', !on);
        var thumb = box.querySelector('[data-mcr-fbt-thumb="' + row.dataset.index + '"]');
        if (thumb) thumb.classList.toggle('is-off', !on);
        var priceEl = row.querySelector('[data-mcr-fbt-price]');
        if (v && priceEl) priceEl.textContent = money(v.price);
        if (!on || !v) return;
        total += v.price;
        compare += Math.max(v.compare, v.price);
        count++;
      });
      totalEl.textContent = money(total);
      if (compareEl) {
        compareEl.hidden = compare <= total;
        compareEl.textContent = compare > total ? money(compare) : '';
      }
      btn.disabled = count === 0;
      if (label) label.textContent = count > 1 && btn.dataset.labelCount ? btn.dataset.labelCount.replace('[count]', count) : btn.dataset.label;
      return count;
    }
    box.__mcrRecalc = recalc;
    box.addEventListener('change', function (e) {
      if (e.target.matches('[data-mcr-fbt-check], [data-mcr-fbt-variant]')) recalc();
    });

    btn.addEventListener('click', function () {
      var items = [];
      rows().forEach(function (row) {
        if (!row.querySelector('[data-mcr-fbt-check]').checked) return;
        var v = selected(row);
        if (v) items.push({ id: +v.id, quantity: 1 });
      });
      err.hidden = true;
      if (!items.length) { err.textContent = box.dataset.empty; err.hidden = false; return; }
      var drawer = doc.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Error');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mcr-fbt', cartData: res });
          }
          if (drawer && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location = box.dataset.cartUrl || '/cart';
          }
        })
        .catch(function (e) { err.textContent = e.message; err.hidden = false; })
        .finally(function () { btn.classList.remove('is-loading'); recalc(); });
    });

    // keep "this item" in sync with the variant chosen on the page
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (p) {
        var v = p && p.data && p.data.variant;
        var row = box.querySelector('[data-mcr-fbt-current]');
        if (!v || !row) return;
        var input = row.querySelector('[data-mcr-fbt-variant]');
        if (input && input.tagName === 'SELECT' && input.querySelector('option[value="' + v.id + '"]')) {
          input.value = String(v.id);
          recalc();
        }
      });
    }
    recalc();
  }

  /* ---------- recommendations swap ---------- */
  function loadRecommendations(section) {
    var url = section.dataset.recoUrl;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        section.querySelectorAll('[data-mcr-upsell-block]').forEach(function (block) {
          var id = block.getAttribute('data-mcr-upsell-block');
          var fresh = html.querySelector('[data-mcr-upsell-block="' + id + '"]');
          if (!fresh) return;
          if (block.dataset.kind === 'bundle') {
            var extras = fresh.querySelector('[data-mcr-fbt-extras]');
            if (!extras || !extras.children.length) return;
            block.querySelector('[data-mcr-fbt-extras]').innerHTML = extras.innerHTML;
            var vis = fresh.querySelector('[data-mcr-fbt-visual]');
            if (vis) block.querySelector('[data-mcr-fbt-visual]').innerHTML = vis.innerHTML;
            var box = block.querySelector('[data-mcr-fbt]');
            box.hidden = false;
            initBundle(box);
          } else {
            if (!fresh.querySelector('[data-mcr-track] > *')) return;
            block.innerHTML = fresh.innerHTML;
            block.querySelectorAll('[data-mcr-slider]').forEach(initSlider);
            if (window.MCR && window.MCR.init) window.MCR.init(block);
          }
        });
      })
      .catch(function () {});
  }

  /* ---------- recently viewed ---------- */
  function initRecent(block) {
    if (block.__mcr) return;
    block.__mcr = true;
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
    var exclude = block.dataset.exclude;
    var limit = parseInt(block.dataset.limit, 10) || 8;
    var root = block.dataset.root || '/';
    if (root.slice(-1) !== '/') root += '/';
    var handles = list.filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    if (!handles.length) return;
    var track = block.querySelector('[data-mcr-recent-list]');
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=mcr-card-only')
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    })).then(function (htmls) {
      var frag = doc.createDocumentFragment();
      htmls.forEach(function (html) {
        if (!html) return;
        var box = new DOMParser().parseFromString(html, 'text/html');
        var card = box.querySelector('.card-wrapper');
        if (!card) return;
        var li = doc.createElement('li');
        li.className = 'mcr-upsell__slide grid__item-slide';
        li.appendChild(doc.importNode(card, true));
        box.querySelectorAll('quick-add-modal').forEach(function (m) { li.appendChild(doc.importNode(m, true)); });
        frag.appendChild(li);
      });
      if (!frag.childNodes.length) return;
      track.appendChild(frag);
      block.hidden = false;
      block.querySelectorAll('[data-mcr-slider]').forEach(function (s) { s.__mcr = false; initSlider(s); });
    });
    var clear = block.querySelector('[data-mcr-recent-clear]');
    if (clear) clear.addEventListener('click', function () {
      try { localStorage.setItem(RV_KEY, JSON.stringify(exclude ? [exclude] : [])); } catch (e) {}
      block.hidden = true;
    });
  }

  function init(scope) {
    scope = scope || doc;
    scope.querySelectorAll('[data-mcr-upsell]').forEach(function (section) {
      if (section.__mcr) return;
      section.__mcr = true;
      section.querySelectorAll('[data-mcr-slider]').forEach(initSlider);
      section.querySelectorAll('[data-mcr-fbt]').forEach(function (b) { if (!b.hidden) initBundle(b); });
      onVisible(section, function () {
        loadRecommendations(section);
        section.querySelectorAll('[data-mcr-recent]').forEach(function (b) {
          whenIdle(function () { initRecent(b); });
        });
      });
    });
    scope.querySelectorAll('[data-mcr-related]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-mcr-slider]').forEach(initSlider);
      if (wrap.__mcrObs || !('MutationObserver' in window)) return;
      wrap.__mcrObs = new MutationObserver(function () {
        wrap.querySelectorAll('[data-mcr-slider]').forEach(initSlider);
      });
      wrap.__mcrObs.observe(wrap, { childList: true, subtree: true });
    });
  }

  window.MCRUpsell = { init: init, initSlider: initSlider };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
